export default __webpack_public_path__ + "static/media/m-desc-sub-banner-1.32762c1a.svg";